import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import { startCase, upperCase, cloneDeep } from "lodash";
import { mapGetters } from "vuex";
import ReferrerFollowUpTab from "../referrer-actions-panel/referrer-follow-up-tab.vue";
import ReferrerTimelineNote from "./referrer-timeline-note.vue";
import { REFERRER_TIMELINE_ITEM } from "@Broker/@Modules/clients/referrers/store/referrer-getters.ts";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerActivityConvertModal",
  components: {
    GenericModal,
    ReferrerFollowUpTab,
    ReferrerTimelineNote
  },
  props: {
    modalId: {
      type: String,
      required: true
    },
    referrerId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      currentItemId: 0,
      currentItemType: ""
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("ReferrerStore", [REFERRER_TIMELINE_ITEM])), {}, {
    timelineItem() {
      return this.REFERRER_TIMELINE_ITEM(this.referrerId, "note", this.currentItemId);
    }
  }),
  methods: {
    handleShow() {
      const {
        id,
        activityType
      } = this.$refs.modal.modalData;
      this.currentItemId = id;
      this.currentItemType = activityType;
    },
    handleShown() {
      this.$nextTick(() => {
        this.$refs.referrerFollowUpTab.initTab();
      });
    },
    handleItemAdd() {
      this.$refs.modal.hide();
    },
    getTimelineComponent(activityType) {
      return `referrer-timeline-${activityType}`;
    },
    getTabData(activityType) {
      const followUpData = {
        description: `${upperCase(this.$t("global.words.from"))} ${upperCase(activityType)}: \n`
      };
      if (activityType === "note") {
        followUpData.description += this.timelineItem.note;
      }
      return cloneDeep(followUpData);
    },
    startCase(string) {
      return startCase(string);
    }
  }
});